import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Viewer } from '@tencent/spaui';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { fetchApplicationById } from 'store/application';
import { preCheck, showAppAuth, showAuth, showDetail, useAuthorized } from 'components/auth';
import nonStandardAuth from 'common/nonStandardAuth';
import { openWin } from 'utils/index';
import OneKeyAuth from 'components/oneKeyAuth/index';
import AddApp from 'components/appBindinng/BindApp';
import './index.scss';
import qs from 'qs';

const vedioTypeReg = /\.(wmv|asf|mp4|mov|rm|rmvb)/i;

const underLine = {
  textDecoration: 'underline',
};

const stopManageApp: any = {
  1111414744: {
    name: '日报生成器（4月15日下线）',
    desc: (
      <div>
        <span style={underLine}>上海弋关网络科技有限公司-日报生成器</span>
        产品/服务，由于业务调整，将于<span style={underLine}>2023年4月15日0时</span>
        起停止运营服务，随即将在营销服务市场（https://isv.e.qq.com/）页面下架。如后续您对该服务有任何疑问，可联系
        info@marketin.cn。对您造成的不便，敬请谅解！
      </div>
    ),
  },
  1111336709: {
    name: '跨账户报表导出（4月15日下线）',
    desc: (
      <div>
        <span style={underLine}>上海弋关网络科技有限公司-跨账户报表导出</span>
        产品/服务，由于业务调整，将于<span style={underLine}>2023年4月15日0时</span>
        起停止运营服务，随即将在营销服务市场（https://isv.e.qq.com/）页面下架。如后续您对该服务有任何疑问，可联系
        info@marketin.cn。对您造成的不便，敬请谅解！
      </div>
    ),
  },
  1112005684: {
    name: '定制分时报表（7月14日下线）',
    desc: (
      <div>
        <span style={underLine}>上海凌枭信息科技有限公司-定制分时报表</span>
        产品/服务，由于业务调整，将于<span style={underLine}>2023年7月24日0时</span>
        起停止运营服务，随即将在营销服务市场（https://isv.e.qq.com/）页面下架。如后续您对该服务有任何疑问，可联系sunwei2@fancydigital.com.cn。对您造成的不便，敬请谅解！
      </div>
    ),
  },
  1111731274: {
    name: '智能模版创建（7月14日下线）',
    desc: (
      <div>
        <span style={underLine}>上海凌枭信息科技有限公司-智能模版创建</span>
        产品/服务，由于业务调整，将于<span style={underLine}>2023年7月24日0时</span>
        起停止运营服务，随即将在营销服务市场（https://isv.e.qq.com/）页面下架。如后续您对该服务有任何疑问，可联系sunwei2@fancydigital.com.cn。对您造成的不便，敬请谅解！
      </div>
    ),
  },
  1111653581: {
    name: '广告清理助手（7月14日下线）',
    desc: (
      <div>
        <span style={underLine}>上海凌枭信息科技有限公司-广告清理助手</span>
        产品/服务，由于业务调整，将于<span style={underLine}>2023年7月24日0时</span>
        起停止运营服务，随即将在营销服务市场（https://isv.e.qq.com/）页面下架。如后续您对该服务有任何疑问，可联系sunwei2@fancydigital.com.cn。对您造成的不便，敬请谅解！
      </div>
    ),
  },
  1112004204: {
    name: '王者通（即将下线）',
    desc: (
      <div>
        <span style={underLine}>广州刁刁信息科技有限公司王者通工具/产品</span>
        由于业务调整原因，于
        <span style={underLine}>近日</span>
        停止服务，产品将在营销服务市场（https://isv.e.qq.com/）页面下架。如您需要继续使用该产品或者服务，可联系fangganmin@kexinshufu.com。特此公示，对您造成的不便，敬请谅解！
      </div>
    ),
  },
};

const ApplicationPage = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const data = useTypedSelector((state) => state.application.list[id]);
  const { authorized, accessPrivilege, authPrivilege } = useAuthorized(id);
  const [loading, setLoading] = useState<boolean>();
  const [viewerIndex, setViewerIndex] = useState<number>(null);
  const {
    app_icon,
    app_name,
    version,
    provider,
    app_desc,
    app_image_list,
    category,
    extra,
    redirect_uri,
    client_bind_status,
  } = data || {};
  const [query, setQuery] = useState<{ [propName: string]: any }>({});
  const [hasAdd, setHasAdd] = useState(client_bind_status || false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!data) {
      dispatch(fetchApplicationById(id));
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  useEffect(() => {
    setQuery(qs.parse(history.location.search, { ignoreQueryPrefix: true }));
  }, [history?.location?.search]);

  if (!data) {
    return null;
  }

  const handleClick = () => {
    if (category > 10) {
      openWin(redirect_uri);
      return;
    }

    // 非标准工具授权
    if (nonStandardAuth(id, (id) => setLoading(!!id))) {
      return;
    }

    if (preCheck()) {
      if (authorized) {
        // 立即使用
        showAppAuth(id);
      } else if (authPrivilege) {
        // 立即开通
        showAuth(id);
      } else {
        showDetail(id, app_name);
      }
    }
  };

  const getElememtA = (tag: string) => {
    const textReg = /\^&\*.*?\^&\*/;
    const hrefReg = /\(.*?\)/;
    const text = tag.match(textReg);
    const href = tag.match(hrefReg);
    let returnText;
    let returnHref;
    if (text) {
      returnText = text[0].replace(/\^&\*/g, '');
    }
    if (href) {
      returnHref = href[0].replace('(', '').replace(')', '');
    }
    return (
      <a style={{ textDecoration: 'underline' }} href={returnHref} target="_blank" rel="noreferrer">
        {returnText}
      </a>
    );
  };

  const getExtraValue = (str: string) => {
    const splitFlag = '^&*';
    const matchLinkReg = /\^&\*.*?\^&\*\(.*?\)/g;
    const elementTag = '--transform2elementTag--';

    const match = str.match(matchLinkReg);
    const after = str.replace(matchLinkReg, `${splitFlag}${elementTag}${splitFlag}`).split(splitFlag);

    return after.map((item) => {
      if (item === elementTag) {
        return getElememtA(match.shift());
      }
      return item;
    });
  };

  let btnText = '立即使用';
  // authorized为true： 我的所有 app 里，包含当前这个应用id 并且他的 authorize_status 不为 false，说人话就是有这个id的权限
  // accessPrivilege role 角色里存在 const legalRoles = [1, 3, 6, 10, 100, 101, 104, 108, 109, 114]; 中的一个或多个
  // authPrivilege 特殊权限 role 角色包含 10 或者角色包含 100 || 被一件开通过
  if (category > 10) {
    btnText = '立即申请';
  }

  if (!category && accessPrivilege && !authorized) {
    btnText = authPrivilege ? '立即开通' : '申请开通';
  }

  return (
    <main className="application-page">
      <OneKeyAuth />
      <div className="header">
        <img src={app_icon} alt="" />
        <div className="info">
          <div className="text-bold name">
            {app_name}
            <div className="version">V {version}</div>
          </div>
          <div className="company">{provider}</div>
          <div className="text-desc">{app_desc}</div>
        </div>
        {query && query.from === 'amshomesgj' && !query.client_id && !hasAdd ? (
          <AddApp
            className="a-button large"
            displayType="primary"
            loading={loading}
            disabled={loading}
            client_id={id}
            onFinish={() => {
              setHasAdd(true);
            }}
          />
        ) : (
          <Button
            className="a-button large"
            displayType="primary"
            loading={loading}
            disabled={loading}
            onClick={handleClick}
          >
            {btnText}
          </Button>
        )}
      </div>
      <div className="detail">
        {app_image_list?.length > 0 && (
          <div className="img-list">
            {app_image_list?.map((item, index) => (
              <div key={index}>
                {item.type === 'video' || item.name.match(vedioTypeReg) ? (
                  <video src={item.url} controls data-track="view-video" data-client-id={id} />
                ) : (
                  <img
                    src={item.url}
                    alt=""
                    data-track="view-image"
                    data-client-id={id}
                    onClick={() => setViewerIndex(index)}
                  />
                )}
              </div>
            ))}
          </div>
        )}
        {stopManageApp[id] && (
          <div className="extra">
            <div className="text-bold">产品停运说明</div>
            <div className="text">{stopManageApp[id].desc}</div>
          </div>
        )}
        {extra?.map((item, index) => (
          <div className="extra" key={index}>
            <div className="text-bold">{item.label}</div>
            <div className="text">{getExtraValue(item.value)}</div>
          </div>
        ))}
      </div>

      <Viewer
        titleBar={false}
        download={false}
        tool={false}
        switchdots
        type="images"
        data={app_image_list}
        show={viewerIndex !== null}
        index={viewerIndex}
        onClose={() => setViewerIndex(null)}
      />

      <aside>
        <div className="item consult">
          <span role="button" />
          <div className="tip-wrapper">
            <span
              style={{ cursor: 'pointer', fontWeight: 'bolder', color: '#fff', paddingBottom: '8px', width: '80px' }}
              id="yzf-btn"
              onClick={() =>
                window.open(
                  'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97d32600c2214498ea14b3b867f34309055de14b8dc0a1596a1c52772ca70682e18c97e443e70db8f922c8c6cb0eb8'
                )
              }
            >
              在线咨询
            </span>
          </div>
        </div>
      </aside>
    </main>
  );
};

export default ApplicationPage;
